module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-return-right-5cd6df40.svg";